import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const EditClientRozCase = (props) => {
  const [value, setValue] = useState(
    props.client.rozCase ? props.client.rozCase : ""
  );
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [holidays, setHolidays] = useState([]);

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data);
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchHolidays();
  };

  useEffect(() => {
    getData();
  }, []);

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const addDay3Months = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 30));
    return retDate;
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= final_date && el.date_from <= final_date) ||
          (final_date >= el.date_from && final_date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const editLead = async (e) => {
    if (value === "") {
      var body = {
        clientId: props.client.id,
        field: "rozCase",
        value: value,
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateClientTableB", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano osobę odpowiedzialną za rozliczenie: " + props.user,
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "klienta",
      }).then(async (result) => {
        props.close();
      });
    } else {
      if (validatePayment()) {
        setLoading(true);
        if (!props.client.rozCase) {
          var date_added =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate() +
            " " +
            new Date().getHours() +
            ":" +
            new Date().getMinutes();
          var date_start =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate();
          var dateFinal = new Date();

          var newFinalDate = addDay3Months(new Date());
          if (newFinalDate.getDay() === 0) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 1)
            );
          }
          if (newFinalDate.getDay() === 6) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 2)
            );
          }

          var date_final = newFinalDate;

          while (
            (checkFree(date_final) || checkHoliday(value, date_final)) &&
            (date_final.getDay() === 0 || date_final.getDay() === 6)
          ) {
            date_final = addDayOne(date_final);
          }

          dateFinal =
            date_final.getFullYear() +
            "-" +
            (date_final.getMonth() + 1) +
            "-" +
            date_final.getDate();

          var body5 = {
            responsible: value,
            start_date: date_start,
            final_date: dateFinal,
            bank: props.client.bank,
            sygn: props.client.aCourt,
            client_name: props.client.petitioner,
            task: "Czy wykonałeś wszystkie czynności związane z rozliczeniem sprawy np. podpisanie porozumienia kompensacyjnego, wysłanie wezwania i oświadczenia o potrąceniu, dodanie płatności do modułu, wysłanie rozliczenia KZP do pełnomocnika banku i rozliczenia SCF do klienta?",
            date_added: date_added,
            user_added: props.user,
            status: "ZLECONE",
            court: props.client.aCourt,
            type: "POZASĄDOWE",
            readed: "no",
            addRole: "admin",
            cycleId: "",
            clientId: props.client.id,
            task_conn: "c",
            team: props.client.team,
            note: "",
          };

          await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body5),
          })
            .then((response) => response.json())
            .then((data) => {
              MySwal.fire({
                icon: "success",
                title: "Edytowano",
                text: "sprawę",
              }).then(async (result) => {
                props.close();
              });
            })
            .catch((error) => {});
        }

        var body = {
          clientId: props.client.id,
          field: "rozCase",
          value: value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateClientTableB", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        props.logClientAction(
          "Edytowano osobę odpowiedzialną za rozliczenie: " + props.user,
          props.client.id
        );

        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "klienta",
        }).then(async (result) => {
          props.close();
        });
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Osoba rozliczająca klienta
                <span className="requiredStar">*</span>
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                }}
              >
                {!value ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <>
                  <option key={0} value={""}>
                    brak danych
                  </option>
                </>
                <>
                  {props.users
                    .filter((el) => el.team.includes(props.client.team))
                    .map((user) => (
                      <option key={user.name} value={user.name}>
                        {user.name}
                      </option>
                    ))}
                </>
              </select>
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLead}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditClientRozCase;
